
import { Component, OnInit,ElementRef, ViewChild,AfterViewInit } from '@angular/core';
import { MDBModalRef,MDBModalService } from 'angular-bootstrap-md';
import { saveAs } from 'file-saver';
import { Subject } from 'rxjs';
import { MatDialog } from "@angular/material/dialog";
import { MatTabGroup } from '@angular/material/tabs';

import { DetArchivoService } from 'src/app/service/det-archivo.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { DetParticipanteService } from 'src/app/service/det-participante.service';

import { AuditoriaBeanM } from 'src/app/model/auditoria_bean';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { DetParticipanteCsv,DetParticipanteE,DetParticipanteM } from 'src/app/model/det-participante-bean';


@Component({
  selector: 'app-dml-cargar-csv',
  templateUrl: './dml-cargar-csv.component.html',
  styleUrls: ['./dml-cargar-csv.component.scss']
})
export class DmlCargarCsvComponent implements OnInit {
  constructor(
    public  modalRefCargarCsvDml: MDBModalRef,
    private dialogo: MatDialog,
    private detParticipanteService:DetParticipanteService,
    private globalVariablesService:GlobalVariablesService,
    private utilitarioService:UtilitarioService,
    private detArchivoService:DetArchivoService
  ){}

   //variables enviado desde el padre
   x_titulo:String;
   c_tipo:String;
   id_constancia:String;
   x_informacion:String;

  rspta_padre = new Response_dml_bean();
   al_agregados:number=0;
   al_enviados:number;
   al_respondidos:number;

  //archivo
  x_fileCsv:File=null;
  @ViewChild('labelArchivoCsv')
  labelArchivoCsv: ElementRef;

  // listado participantes
  listaincluyecodigo:boolean=false;
  semuestralista:boolean=false;
  listParticipantesCsv = new Array<DetParticipanteCsv>();


  page = 1;
  pageSize = 10;
  @ViewChild('tabGroup', {static: false}) tab: MatTabGroup;


  //action del padre para el retorno de datos
  action: Subject<Response_dml_bean> = new Subject();

  ngOnInit(): void {
    this.rspta_padre.codigoRespuestaServicio ="0";
    this.rspta_padre.mensaje="";

  }
  LeerArchivoCSV(file: File){

    this.utilitarioService.loading = true;
    var reader = new FileReader();
    var codigoaux = "0";
    reader.onloadend  = () => {
      //console.log(reader.result);
      let csvToRowArray = reader.result.toString().split("\n");
      for (let index = 1; index < csvToRowArray.length - 1; index++) {
        let row = csvToRowArray[index].split(";");
        if(row.length==1)
          row = csvToRowArray[index].split(",");

        if(this.listaincluyecodigo)
          codigoaux = row[3].trim();

        this.listParticipantesCsv.push(new DetParticipanteCsv( row[0], row[1], row[2].trim(),codigoaux));
      }
      //console.log(this.listParticipantesCsv);

      this.semuestralista = true;
      this.tab.selectedIndex = 1;
      this.utilitarioService.loading = false;
            //this.x_resultado = this.participantesArray[0].nombre;
            //this.x_informacion = 'Se agregaran '+ this.participantesArray.length.toString()+' participantes';
    };
    reader.onerror = () => {
      this.semuestralista = false;
      this.utilitarioService.loading = false;
      this.utilitarioService.toastrInfo("Hubo un error al leer el archivo, intente nuevamente.");
    };
    reader.readAsText(file,'ISO-8859-1');
  }
  onFileCsvChange(files: FileList){

    this.labelArchivoCsv.nativeElement.innerText = Array.from(files)
      .map(f => f.name)
      .join(', ');

    this.x_fileCsv = files.item(0);
    console.log(files.item(0));


    if((this.x_fileCsv.name.endsWith(".CSV")||this.x_fileCsv.name.endsWith(".csv")) &&
       ((this.x_fileCsv.type == "text/csv")||(this.x_fileCsv.type =="application/vnd.ms-excel")))
    {
      this.listParticipantesCsv = new Array<DetParticipanteCsv>();
      this.LeerArchivoCSV(this.x_fileCsv);
    }
    else
    {
      this.semuestralista = false;
      this.utilitarioService.toastrInfo("Debe seleccionar el archivo en formato de la plantilla .CSV");
    }

  }

  onAgregarTodosRecurIni()
  {
    this.utilitarioService.loading=true;

    this.al_agregados = 0;
    this.al_enviados=0;
    this.al_respondidos=0;

    this.onAgregarRecursivo();
  }
  onAgregarRecursivo()
  {
    var parti_CSV = this.listParticipantesCsv[this.al_enviados];

    let auditoriaBeanM = new AuditoriaBeanM();
       auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio('I');
    var participanteE = new DetParticipanteE();
        participanteE.c_constancia = this.id_constancia;
        participanteE.c_tipo = this.c_tipo;
        participanteE.c_userid = "0";
        participanteE.x_nombres =parti_CSV.nombre;
        participanteE.x_correo = parti_CSV.correo;
        participanteE.x_nota = parti_CSV.nota;
        participanteE.x_nro_constancia =parti_CSV.codigo;;
        participanteE.c_estado = 21;
        participanteE.x_uid_doc = "0";
        participanteE.x_uid_pdf = "0";
        participanteE.l_envio_correo = "0";
        participanteE.auditoriaBeanM = auditoriaBeanM;

        this.detParticipanteService.insert(participanteE).subscribe((response_dml_bean:Response_dml_bean)=>{
          this.al_respondidos++;

          if (response_dml_bean.codigoRespuestaServicio=="1")
            this.al_agregados++;


          this.onConfirmarFinalRecursivo();
        },
        error=>{
          this.al_respondidos++;
          console.log(error);

          this.onConfirmarFinalRecursivo();
        });
  }

  onConfirmarFinalRecursivo()
  {
    if( this.al_respondidos==this.listParticipantesCsv.length)
    {
      this.utilitarioService.loading=false;
      if(this.al_agregados>0)
      {
        this.rspta_padre.codigoRespuestaServicio = "1";
        if(this.al_agregados>1)
          this.rspta_padre.mensaje ="Se agrego "+this.al_agregados.toString()+ " participantes";//+this.x_tipo;
        else
          this.rspta_padre.mensaje ="Se agrego un nuevo participante";

        this.onClosemodal();
      }
      else
        this.utilitarioService.toastrInfo("No se agrego ningun participante");
    }
    else
    {
      this.al_enviados++;
      this.onAgregarRecursivo();
    }
  }

  onAgregarTodos()
  {
    this.utilitarioService.loading=true;
    this.al_agregados = 0;
    var ejecutados = 0;
    let auditoriaBeanM = new AuditoriaBeanM();
    auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio('I');

    var i:number;
    for(i = 0;i<this.listParticipantesCsv.length;i++) {
        var participanteE = new DetParticipanteE();
        participanteE.c_constancia = this.id_constancia;
        participanteE.c_tipo = this.c_tipo;
        participanteE.c_userid = "0";
        participanteE.x_nombres = this.listParticipantesCsv[i].nombre;
        participanteE.x_correo = this.listParticipantesCsv[i].correo;
        participanteE.x_nota = this.listParticipantesCsv[i].nota;
        participanteE.x_nro_constancia = this.listParticipantesCsv[i].codigo;;
        participanteE.c_estado = 21;
        participanteE.x_uid_doc = "0";
        participanteE.x_uid_pdf = "0";
        participanteE.l_envio_correo = "0";
        participanteE.auditoriaBeanM = auditoriaBeanM;

        this.detParticipanteService.insert(participanteE).subscribe((response_dml_bean:Response_dml_bean)=>{
          ejecutados++;
          if (response_dml_bean.codigoRespuestaServicio=="1")
            this.al_agregados++;

          if(ejecutados==this.listParticipantesCsv.length)
          {
            this.utilitarioService.loading=false;
            if(this.al_agregados>0)
            {
              this.rspta_padre.codigoRespuestaServicio = "1";
              if(this.al_agregados>1)
                this.rspta_padre.mensaje ="Se agrego "+this.al_agregados.toString()+ " participantes";//+this.x_tipo;
              else
                this.rspta_padre.mensaje ="Se agrego un nuevo participante";

              this.onClosemodal();
            }
            else
              this.utilitarioService.toastrInfo("No se agrego ningun participante");
          }
        },
        error=>{
          console.log(error);
        });
   }
  }

  onDescargarPlantilla()  {
    var ruta_open = '32bcf905-9469-4015-b971-1dcdd3fa256f';
    var nombre = 'plantilla_carga.csv';
    if(this.listaincluyecodigo)
    {
      ruta_open = 'c9290211-d842-438e-8893-2c160e496f90';
      nombre = 'plantilla_carga_codigo.csv';
    }

    this.utilitarioService.loading = true;
    this.detArchivoService.getFile(ruta_open).subscribe(blob=>{
      this.utilitarioService.loading = false;
      saveAs(blob,nombre);
    });
  }
  onClosemodal(){
    this.action.next(this.rspta_padre);
    this.modalRefCargarCsvDml.hide();
  }
}
